// removed by extract-text-webpack-plugin
module.exports = {"left":"type__left___1wAb1 textAlign-left","center":"type__center___1qmwE textAlign-center","right":"type__right___256ff textAlign-right","top":"type__top___1WoGh display-tableCell verticalAlign-top","middle":"type__middle___2L7B5 display-tableCell verticalAlign-middle","bottom":"type__bottom___3MV5i display-tableCell verticalAlign-bottom"};


//////////////////
// WEBPACK FOOTER
// ./packages/marvel-ui-align/Align/style/type.css
// module id = 79
// module chunks = 0 16